export const flowData = [
    {
        style: "bg-blue-200 w-40 my-2 py-2 mx-2 rounded-md cursor-grab shadow-lg",
        type: "nodeA",
        text: "NODE_A",
        title: "Drag this INPUT_2"
    },
    {
        style: "bg-blue-200 w-40 my-2 py-2 mx-2 rounded-md cursor-grab shadow-lg",
        type: "nodeB",
        text: "NODE_B",
        title: "Drag this INPUT_2"
    },
];